import { buildCheckInOutSnapshot } from "../../checkin/utils/checkInOut";

const buildCheckOutReservationPatch = ({ carImages, fuelLevel, mileage }) => {
    const checkOut = buildCheckInOutSnapshot({ carImages, fuelLevel, mileage });
    const payload = {};

    if (checkOut) {
        payload.checkOut = checkOut;
    }

    // Deliberately not `isCarDroppedOff: true`. TeqMobility and ABI refuse to end coverage once the
    // car is marked dropped off. `POST /api/reservation/check-out/:id` sets that flag after insurance ends.
    payload.exactDropoffTime = new Date().toISOString();
    payload.ongoing = false;

    return payload;
};

export default buildCheckOutReservationPatch;
